export const FETCH_LATEST_VERSION  = "FETCH_LATEST_VERSION";
export const SET_LATEST_VERSION  = "SET_LATEST_VERSION";
export const FETCH_DRAWER_MENU = "FETCH_DRAWER_MENU";
export const SET_DRAWER_MENU  = "SET_DRAWER_MENU";
export const FETCH_BANNER = "FETCH_BANNER";
export const SET_BANNER  = "SET_BANNER";
export const SET_LOADING  = "SET_LOADING";
export const FETCH_PRODUCT_LIST = "FETCH_PRODUCT_LIST";
export const SET_PRODUCT_LIST  = "SET_PRODUCT_LIST";
export const CLEAR_PRODUCT_LIST = "CLEAR_PRODUCT_LIST"
export const FETCH_COLOR_LIST = "FETCH_COLOR_LIST";
export const SET_COLOR_LIST  = "SET_COLOR_LIST";
export const FETCH_SPACE_LIST = "FETCH_SPACE_LIST";
export const SET_SPACE_LIST  = "SET_SPACE_LIST";
export const FETCH_TOTAL_COUNT_LIST = "FETCH_TOTAL_COUNT_LIST";
export const SET_TOTAL_COUNT_LIST  = "SET_TOTAL_COUNT_LIST";
export const FETCH_PRODUCT_MODAL_DATA_LIST = "FETCH_PRODUCT_MODAL_DATA_LIST";
export const SET_PRODUCT_MODAL_DATA_LIST  = "SET_PRODUCT_MODAL_DATA_LIST";
export const CLEAR_PRODUCT_MODAL_DATA_LIST  = "CLEAR_PRODUCT_MODAL_DATA_LIST";
export const FETCH_SHOW_MORE_PRODUCT_LIST = "FETCH_SHOW_MORE_PRODUCT_LIST";
export const SET_SHOW_MORE_PRODUCT_LIST  = "SET_SHOW_MORE_PRODUCT_LIST";
export const CLEAR_SHOW_MORE_PRODUCT_LIST  = "CLEAR_SHOW_MORE_PRODUCT_LIST";
export const SET_LICENCE  = "SET_LICENCE";
export const FETCH_LICENCE  = "FETCH_LICENCE";
export const SET_LIKE  = "SET_LIKE";
export const FETCH_LIKE  = "FETCH_LIKE";
export const SET_DISLIKE  = "SET_DISLIKE";
export const FETCH_DISLIKE  = "FETCH_DISLIKE";
export const FETCH_SHOW_MORE_COLLECTION_LIST = "FETCH_SHOW_MORE_COLLECTION_LIST";
export const SET_SHOW_MORE_COLLECTION_LIST  = "SET_SHOW_MORE_COLLECTION_LIST";
export const CLEAR_SHOW_MORE_COLLECTION_LIST  = "CLEAR_SHOW_MORE_COLLECTION_LIST";
export const SET_LIKE_COLLECTION  = "SET_LIKE_COLLECTION";
export const FETCH_LIKE_COLLECTION  = "FETCH_LIKE_COLLECTION";
export const SET_DISLIKE_COLLECTION  = "SET_DISLIKE_COLLECTION";
export const FETCH_DISLIKE_COLLECTION  = "FETCH_DISLIKE_COLLECTION";
export const FETCH_COLLECTION_MODAL_DATA_LIST = "FETCH_COLLECTION_MODAL_DATA_LIST";
export const SET_COLLECTION_MODAL_DATA_LIST  = "SET_COLLECTION_MODAL_DATA_LIST";
export const FETCH_SIGN_UP = "FETCH_SIGN_UP";
export const SET_SIGN_UP  = "SET_SIGN_UP";
export const FETCH_SIGN_IN = "FETCH_SIGN_IN";
export const SET_SIGN_IN  = "SET_SIGN_IN";



export const INITIALIZE = "INITIALIZE"
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS"
export const SIGN_UP = "SIGN_UP"
export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS"
export const SIGN_IN = "SIGN_IN"
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS"

export const FETCH_SINGLE_BANNER = "FETCH_SINGLE_BANNER";
export const SET_SINGLE_BANNER = "SET_SINGLE_BANNER";
export const CLEAR_SINGLE_BANNER = "CLEAR_SINGLE_BANNER";

export const FETCH_PROFILE = "FETCH_PROFILE";
export const SET_PROFILE = "SET_PROFILE";
export const CLEAR_PROFILE = "CLEAR_PROFILE";



export const FETCH_SINGLE_CATEGORY_FILE = "FETCH_SINGLE_CATEGORY_FILE";
export const SET_SINGLE_CATEGORY_FILE = "SET_SINGLE_CATEGORY_FILE";
export const CLEAR_SINGLE_CATEGORY_FILE = "CLEAR_SINGLE_CATEGORY_FILE";



export const FETCH_FAVORITE_FILES = "FETCH_FAVORITE_FILES";
export const SET_FAVORITE_FILES = "SET_FAVORITE_FILES";
export const CLEAR_FAVORITE_FILES = "CLEAR_FAVORITE_FILES";



export const FETCH_FAVORITE_COLLECTION = "FETCH_FAVORITE_COLLECTION";
export const SET_FAVORITE_COLLECTION = "SET_FAVORITE_COLLECTION";
export const CLEAR_FAVORITE_COLLECTION = "CLEAR_FAVORITE_COLLECTION";

export const FETCH_ACTIVE_LICENSE = "FETCH_ACTIVE_LICENSE";
export const SET_ACTIVE_LICENSE = "SET_ACTIVE_LICENSE";
export const CLEAR_ACTIVE_LICENSE = "CLEAR_ACTIVE_LICENSE";



export const FETCH_FORGET_PASSWORD = "FETCH_FORGET_PASSWORD";
export const SET_FORGET_PASSWORD = "SET_FORGET_PASSWORD";
export const CLEAR_FORGET_PASSWORD = "CLEAR_FORGET_PASSWORD";

